import React from "react";
import PropTypes from "prop-types";
import { Select, Toggle } from "@opendate-app/setlist";

const DEAL_TYPE_OPTIONS = [
  { value: "sales", label: "Sales" },
  { value: "fundraising", label: "Fundraising" },
];

const questionOptions = (questions, type) => questions
  .filter((question) => question.type === type && (question.label || "").trim())
  .map((question) => ({ value: question.key, label: question.label }));

const DealSettingsEditor = ({ value, onChange, owners = [], questions = [] }) => {
  const update = (changes) => onChange({ ...value, ...changes });
  const amountOptions = questionOptions(questions, "number");
  const closeDateOptions = questionOptions(questions, "date");

  return (
    <div className="sf-deal-settings">
      <div className="sf-field-toggle-head">
        <Toggle
          id="sf-deals-enabled"
          size="sm"
          checked={!!value.enabled}
          onChange={() => update({ enabled: !value.enabled })}
        />
        <label className="sf-field-toggle-title" htmlFor="sf-deals-enabled">Create a deal for each submission</label>
      </div>
      {value.enabled && (
        <div className="sf-field-toggle-detail">
          <Select
            id="sf-deal-type"
            size="sm"
            label="Deal type"
            options={DEAL_TYPE_OPTIONS}
            value={value.deal_type || "sales"}
            onChange={(dealType) => update({ deal_type: dealType || "sales" })}
          />
          <Select
            id="sf-deal-owner"
            size="sm"
            label="Owner"
            placeholder="No owner"
            searchable
            clearable
            options={owners}
            value={value.owner_team_membership_id ?? null}
            onChange={(ownerId) => update({ owner_team_membership_id: ownerId ?? null })}
          />
          <Select
            id="sf-deal-amount-question"
            size="sm"
            label="Amount from"
            placeholder={amountOptions.length ? "Don't set an amount" : "Add a number question first"}
            clearable
            disabled={!amountOptions.length}
            options={amountOptions}
            value={value.amount_question_key ?? null}
            onChange={(key) => update({ amount_question_key: key ?? null })}
          />
          <Select
            id="sf-deal-close-date-question"
            size="sm"
            label="Close date from"
            placeholder={closeDateOptions.length ? "Don't set a close date" : "Add a date question first"}
            clearable
            disabled={!closeDateOptions.length}
            options={closeDateOptions}
            value={value.close_date_question_key ?? null}
            onChange={(key) => update({ close_date_question_key: key ?? null })}
          />
        </div>
      )}
    </div>
  );
};

DealSettingsEditor.propTypes = {
  value: PropTypes.shape({
    enabled: PropTypes.bool,
    deal_type: PropTypes.string,
    owner_team_membership_id: PropTypes.number,
    amount_question_key: PropTypes.string,
    close_date_question_key: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  owners: PropTypes.arrayOf(PropTypes.shape({ value: PropTypes.number, label: PropTypes.string })),
  questions: PropTypes.arrayOf(PropTypes.shape({ key: PropTypes.string, type: PropTypes.string, label: PropTypes.string })),
};

export default DealSettingsEditor;
